import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';

export const apiInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    if (request.url.includes('api') && !request.url.includes('common') && !request.url.includes('apps')) {
        const baseUrl = environment.apiUrl;
        request = request.clone({ url: baseUrl + request.url });
    }

    return next(request).pipe(
        catchError((err, caught) => {
            console.error('API Error:', err);
            let message = 'An error occurred - Please contact support';

            if (err.error?.errors) {
                message = '';

                for (const key in err.error.errors)
                    for (const error of err.error.errors[key])
                        message += error + '\n';

                message = message.trim();
            } else if (err.error?.detail)
                message = err.error.detail;

            return throwError(() => new Error(message));
        })
    );
};
